import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import StatusIconBuilder from './StatusIconBuilder';
const DriverStatusIcon = (props) => {
    if (!props.driverLocation) {
        return null;
    }
    const imgSrc = StatusIconBuilder.buildIcon(props.driverLocation);
    return (_jsx("img", { src: imgSrc, width: "56", height: "26" }));
};
export default DriverStatusIcon;
